export const DEFAULT_ACTION = 'app/UpgradeAccountPage/DEFAULT_ACTION';
export const UPGRADE_ACCOUNT_PAGE_INIT = 'UPGRADE_ACCOUNT_PAGE/INIT';
export const UPGRADE_ACCOUNT_PAGE_ADD_DOMAIN =
  'UPGRADE_ACCOUNT_PAGE/ADD_DOMAIN';
export const UPGRADE_ACCOUNT_PAGE_ADD_DOMAIN_SUCCESS =
  'UPGRADE_ACCOUNT_PAGE/ADD_DOMAIN_SUCCESS';
export const UPGRADE_ACCOUNT_PAGE_ADD_DOMAIN_ERROR =
  'UPGRADE_ACCOUNT_PAGE/ADD_DOMAIN_ERROR';

export const UPGRADE_ACCOUNT_PAGE_REMOVE_DOMAIN =
  'UPGRADE_ACCOUNT_PAGE/REMOVE_DOMAIN';
export const UPGRADE_ACCOUNT_PAGE_REMOVE_DOMAIN_SUCCESS =
  'UPGRADE_ACCOUNT_PAGE/REMOVE_DOMAIN_SUCCESS';
export const UPGRADE_ACCOUNT_PAGE_REMOVE_DOMAIN_ERROR =
  'UPGRADE_ACCOUNT_PAGE/REMOVE_DOMAIN_ERROR';

export const UPGRADE_ACCOUNT_PAGE_UPDATE_USER =
  'UPGRADE_ACCOUNT_PAGE/UPDATE_USER';
export const UPGRADE_ACCOUNT_PAGE_UPDATE_USER_SUCCESS =
  'UPGRADE_ACCOUNT_PAGE/UPDATE_USER_SUCCESS';
export const UPGRADE_ACCOUNT_PAGE_UPDATE_USER_ERROR =
  'UPGRADE_ACCOUNT_PAGE/UPDATE_USER_ERROR';
export const UPGRADE_ACCOUNT_RESET =
  'UPGRADE_ACCOUNT_PAGE/UPGRADE_ACCOUNT_RESET';
export const UPGRADE_ACCOUNT_IN_PROGRESS =
  'UPGRADE_ACCOUNT_PAGE/UPGRADE_ACCOUNT_IN_PROGRESS';
export const EXTEND_TRIAL = 'UPGRADE_ACCOUNT_PAGE/EXTEND_TRIAL';
